export const compareRanks = (a, b) => {
    const firstDesktopRank = a?.rank?.desktop || null;
    const secondDesktopRank = b?.rank?.desktop || null;
    const firstMobileRank = a?.rank?.mobile || null;
    const secondMobileRank = b?.rank?.mobile || null;

    return (firstDesktopRank || firstMobileRank) - (secondDesktopRank || secondMobileRank);
};
